import axios from 'axios';

export default axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization: 'Client-ID 0lNGj3s3IlETyHwUQEStIEa7LaAFQWtH3fz4M5onUYQ'
  }
});